<div class="stepper-container">
  <div class="header">
    <img src="../../../../assets/Logos/IQ toolbox logo.png" alt="Stanley IQ logo" width="50" height="50" onerror="this.style.display='none'" />
    <h1>Stanley IQ Toolbox Subscription Configuration</h1>
  </div>
  <hr />

  <mat-horizontal-stepper [linear]="isLinear" #stepper>

    <!-- Step 1: Product -->
    <mat-step [stepControl]="firstFormGroup">
      <ng-template matStepLabel>Products</ng-template>
      <form [formGroup]="firstFormGroup">
        <div class="sub-identifier-section">
          <div class="section-header">
            <mat-icon>label</mat-icon>
            <h3>Subscription Identifier / Company Name</h3>
          </div>
          <mat-form-field class="full-width">
            <mat-label>Identifier</mat-label>
            <input matInput formControlName="subscriptionIdentifier" placeholder="Enter unique identifier for ease of identification" maxlength="100" />
          </mat-form-field>
        </div>
        <div><h2>Select Product</h2></div>
        <div class="products">
          <div class="product-cards">
            @for (product of products; track product.product.id) {
            <mat-card class="product-card" [ngClass]="{ selected: selectedProduct?.product?.id === product.product.id }" (click)="selectProduct(product)">
              <mat-card-header>
                <mat-card-title>{{ product.product.name }}</mat-card-title>
                <mat-card-subtitle>{{ product.product.productFamily.name }}</mat-card-subtitle>
              </mat-card-header>
              <mat-card-content>
                <p>{{ product.product.description || 'No description available.' }}</p>
                <p class="price-label">Price annually: ${{ (product.product.priceInCents ?? 0) / 100 }}</p>
              </mat-card-content>
            </mat-card>
            }
            @if (products.length === 0) { <p>No products available.</p> }
          </div>
        </div>
      </form>
    </mat-step>

    <!-- Step 2: Configuration -->
    <mat-step [stepControl]="secondFormGroup">
      <ng-template matStepLabel>Configuration</ng-template>
      <form [formGroup]="secondFormGroup">
        <div><h2>Configure Subscription</h2></div>
        <div class="ci-inputs">
          <div class="plan-section">
            <div class="section-header">
              <mat-icon>dashboard_customize</mat-icon>
              <h3>Product: {{ selectedProduct?.product?.name || 'No product selected' }}</h3>
            </div>
            <div class="plan-details">
              <div class="components-container" formArrayName="components">
                <div class="component-card" *ngFor="let componentControl of components.controls; let i = index" [formGroupName]="i">
                  <h3>Component Details</h3>
                  <mat-form-field class="full-width">
                    <mat-label>Component</mat-label>
                    <mat-select formControlName="component" [displayWith]="displayComponentName" (selectionChange)="onComponentChange($event.value, i)" required>
                      <mat-option *ngFor="let option of componentOptions" [value]="option" [disabled]="isComponentSelected(option, i)">{{ option.name }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="full-width">
                    <mat-label>Quantity</mat-label>
                    <input matInput type="number" formControlName="allocatedQuantity" required />
                    <mat-error *ngIf="componentControl.get('allocatedQuantity')?.hasError('min')">Quantity must be at least 1.</mat-error>
                  </mat-form-field>
                  <div class="component-price">
                    @if (!componentControl.get('useCustomPrice')?.value) {
                    <h4>Price per Unit: {{ componentControl.get('component')?.value?.prices?.[0]?.formattedUnitPrice }}</h4>
                    }
                    <mat-checkbox formControlName="useCustomPrice" (change)="toggleCustomPrice(i)">Use Custom Price</mat-checkbox>
                  </div>
                  @if (componentControl.get('useCustomPrice')?.value) {
                  <mat-form-field class="full-width">
                    <mat-label>Set Custom Price Per Unit</mat-label>
                    <input matInput type="number" formControlName="customPrice" placeholder="Enter custom price" required />
                  </mat-form-field>
                  }
                  <div class="action-buttons">
                    <button mat-button color="primary" (click)="addComponent()"><mat-icon>add</mat-icon> Add Component</button>
                    <button mat-button color="warn" (click)="removeComponent(i)"><mat-icon>remove</mat-icon> Remove Component</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="price-section">
            <div class="section-header"><mat-icon>attach_money</mat-icon><h3>Price</h3></div>
            <div class="price-details">
              <h3>Total Price: ${{ totalPrice }}</h3>
              @for (item of selectedComponents; track item.component.id; let i = $index) {
              <h4>{{ item.component.name }}: {{ item.quantity }} x {{ components.at(i)?.get('useCustomPrice')?.value ? (components.at(i)?.get('customPrice')?.value | currency:'USD':'symbol':'1.2-2') : item.component.prices[0]?.formattedUnitPrice || 'N/A' }}</h4>
              }
            </div>
          </div>
        </div>

        <div class="bottom-section">
          <div class="integrator-section" [formGroup]="metafieldsGroup">
            <div class="section-header"><mat-icon>info_outline</mat-icon><h3>Information</h3></div>
            <mat-form-field class="full-width">
              <mat-label>Distribution Network Level</mat-label>
              <mat-select formControlName="distributionNetworkLevel">
                <mat-option value="bronze">Bronze</mat-option>
                <mat-option value="silver">Silver</mat-option>
                <mat-option value="gold">Gold</mat-option>
                <mat-option value="platinum">Platinum</mat-option>
                <mat-option value="other">Other</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>Customer ID</mat-label>
              <input matInput formControlName="customerId" />
            </mat-form-field>
          </div>
          <div class="integrator-section">
            <div class="section-header"><mat-icon>person</mat-icon><h3>Purchase Information</h3></div>
            <mat-form-field class="full-width">
              <mat-label>Enter Email Address</mat-label>
              <input matInput formControlName="purchaserEmail" placeholder="...Enter purchaser email" />
            </mat-form-field>
            <p><em>*Enter the purchaser's email. They will receive an invite email to log in and pay for preconfigured subscription.</em></p>
          </div>
        </div>
      </form>
    </mat-step>

  </mat-horizontal-stepper>

  <div class="stepperControls padding s6 all">
    <button mat-button class="previousStepButton" routerLink="/sat-subscriptions">Home</button>
    <div class="previous-save-button-container">
      <div class="button-container">
        <button mat-button class="previousStepButton" (click)="goToPreviousStep()" *ngIf="(stepper?.selectedIndex ?? 0) > 0">Previous</button>
        <button mat-raised-button class="nextStepButton" (click)="goToNextStep()" [disabled]="!isCurrentStepValid()" *ngIf="shouldShowNextButton()">Next</button>
      </div>
      <button mat-raised-button class="nextStepButton" (click)="onSubmit()" [disabled]="!isCurrentStepValid()" *ngIf="shouldShowSaveButton()">Save Subscription</button>
    </div>
  </div>
</div>
